/*
 *    Copyright (c) 2018-2025, lengleng All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: lengleng (wangiegie@gmail.com)
 */

import request from '@/router/axios'

export function fetchList(query) {
	return request({
		url: '/admin/user/page',
		method: 'get',
		params: query,
	})
}

export function addObj(obj) {
	return request({
		url: '/admin/user',
		method: 'post',
		data: obj,
	})
}

export function getObj(id) {
	return request({
		url: '/admin/user/' + id,
		method: 'get',
	})
}

export function delObj(id) {
	return request({
		url: '/admin/user/' + id,
		method: 'delete',
	})
}

export function putObj(obj) {
	return request({
		url: '/admin/user',
		method: 'put',
		data: obj,
	})
}

export function getDetails(obj) {
	return request({
		url: '/admin/user/details/' + obj,
		method: 'get',
	})
}

// 更改个人信息
export function editInfo(obj) {
	return request({
		url: '/admin/user/edit',
		method: 'put',
		data: obj,
	})
}

export function channelReport() {
	return request({
		url: '/dist/channelReport/my',
		method: 'get',
	})
}

export function generatedContactCode(data) {
	return request({
		url: `/dist/contact/code?appId=${data.appId}`,
		method: 'post',
		data,
	})
}

/**
 * 获取公共参数
 * @param key
 * @returns {Promise<void>}
 */
export function getPublicValue(key) {
	return request({
		url: '/admin/param/publicValue/' + key,
		method: 'get',
	})
}
